import { useMutation } from '@tanstack/react-query'
import { useToast } from '@zet/common/components/toast'
import { i18n } from '@zet/localization'

import { uploadDocumentToS3 } from './function'

export const useDocumentUploadToS3 = () => {
  const toast = useToast()

  return useMutation({
    mutationFn: (props: { S3Url: string; file: any }) => {
      return uploadDocumentToS3(props?.S3Url, props?.file)
    },
    onSuccess: () => {
      toast?.show({
        intent: 'success',
        heading: 'Document Uploaded succesfully',
        hideAfter: 3000,
      })
    },
    onError: () => {
      toast?.show({
        intent: 'error',
        heading: i18n.t('toastMessages.error'),
        description: i18n.t('toastMessages.somethingWentWrong'),
        hideAfter: 3000,
      })
    },
  })
}
